import React from "react";
import { Link } from "react-router-dom";
import aiImage from "../../../assets/VM.jpg";
import strategyImage from "../../../assets/VM1.jpg";

export default function VideoMarketing() {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Video Marketing"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-80"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Video Marketing
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Create promotional videos, explainers, reels, and corporate stories that elevate brand recall
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Video Marketing"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-white text-center lg:text-left">
                Video Marketing
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Create promotional videos, explainers, reels, and corporate stories that elevate brand recall.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed text-center lg:text-left">
                Our video marketing expertise helps you tell compelling stories through visual content that captures attention, builds emotional connections, and drives action.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Marketing Services Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white">
            We Provide A Full Range Of Video Marketing Services
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold text-center mb-12 text-[#B31F7E]">
            Video Marketing Services
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Brand Videos */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Brand Videos
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Showcase the essence of your brand through dedicated video content.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Corporate Video Production */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Corporate Video Production
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Corporate videos communicate important marketing messages with your audience or employees.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Animated Video Production */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Animated Video Production
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Short-form motion pictures for your brand that effectively communicate ideas and processes.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Photography */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Photography
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Professional photography services to provide you with a content library of evocative imagery.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Shoppable Video Content */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Shoppable Video Content
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Showcase your products in strategically placed lifestyle video content which is directly shoppable from the clip.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Interactive Videos */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Interactive Videos
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Share content that people can actively engage with at the touch of a button.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Event Coverage */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Event Coverage
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Capture moments in real-time with complete video coverage for maximum views and sources of content, from live feeds to recordings to be packaged for later use.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Post Production Services */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Post Production Services
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Transforming raw footage with editing to give your video content the edge, from audio to edits and post-production imagery.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* eLearning & Training Videos */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                eLearning & Training Videos
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Explain new concepts and techniques to teams in simplified onboarding and training, saving you both time and money.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Social Media Videos */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Videos
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Share your videos on social media, one of the best places for video consumption and engagement, with strategies devised for each platform.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* Video Content Strategy */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Video Content Strategy
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Developing a content strategy to reach more audiences, optimize the content, maximize the engagement, and measure performance.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>

            {/* TV Commercials */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h4 className="text-xl font-bold mb-4 text-[#B31F7E]">
                TV Commercials
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Produce professional video content suited for TV commercials to generate mass awareness and interest in your brand from start to finish.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}